import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '../assets/alarm_clock.png';
import _imports_1 from '../assets/copy_url.png';
const _hoisted_1 = {
  id: "",
  class: "position-relative",
  style: {
    "height": "45px",
    "box-sizing": "border-box",
    "padding": "2px 3px 0 3px",
    "z-index": "12"
  }
};
const _hoisted_2 = {
  id: "",
  style: {
    "background-color": "#3982cc"
  },
  class: "h-100 w-100 flex align-center justify-center text-white"
};
const _hoisted_3 = {
  style: {
    "font-size": "12px",
    "margin-top": "5px",
    "margin-left": "5px"
  }
};
const _hoisted_4 = {
  class: "font-bold",
  style: {
    "margin": "0 5px",
    "font-size": "16px"
  }
};
const _hoisted_5 = {
  style: {
    "font-size": "12px",
    "margin-top": "3px"
  }
};
const _hoisted_6 = {
  key: 0,
  id: " ",
  style: {
    "line-height": "45px"
  },
  class: "top-0 left-0 right-0 bottom-0 text-left position-absolute flex align-center"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  style: {
    "width": "25px",
    "height": "25px",
    "margin-left": "10px"
  }
}, null, -1);
const _hoisted_8 = {
  style: {
    "margin-left": "3px",
    "margin-top": "6px"
  },
  class: "text-white font-bold"
};
const _hoisted_9 = {
  id: " ",
  style: {
    "line-height": "45px"
  },
  class: "top-0 left-0 right-0 bottom-0 text-right position-absolute"
};
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import useClipboard from "vue-clipboard3";
import { ElMessage } from "element-plus";
import { getLocalPid } from "../libs/util";
import { getSitename } from "../api/index";
export default {
  __name: 'title',
  props: {
    timer: {
      type: Number,
      default: 0
    },
    articleId: {
      type: [String, Number],
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const {
      toClipboard
    } = useClipboard();
    const store = useStore();
    const timer = ref(props.timer);
    const articleId = ref(props.articleId);
    const time = ref(0);
    let maxW = ref(100000);
    const pid = getLocalPid();
    const title = computed(() => store.state.title);
    const userInfo = computed(() => store.state.userInfo);
    const timeFomat = computed(() => {
      if (time.value < 0) {
        return "0:00";
      }
      if (time.value % 60 < 10) {
        return Math.floor(time.value / 60) + " : 0" + time.value % 60;
      }
      return Math.floor(time.value / 60) + ":" + time.value % 60;
    });
    onMounted(() => {
      maxW.value = document.body.clientWidth;
      if (!title.value) getTitle();
      var a = setInterval(() => {
        if (timer.value > 0) {
          time.value = timer.value;
          timerMinus();
          clearInterval(a);
        }
      }, 500);
    });
    const timerMinus = () => {
      setInterval(() => {
        time.value--;
      }, 1000);
    };
    const getTitle = () => {
      // 请求title
      setTimeout(() => {
        getSitename({
          pid: pid
        }).then(res => {
          let data = res.data;
          if (data.code === 0) {
            store.commit("getTitle", data.data.siteName);
            localStorage.setItem("title", data.data.siteName);
            document.title = data.data.siteName;
          } else {
            ElMessage.error(data.msg);
          }
        }).catch(() => {
          ElMessage.error("标题请求失败");
        });
      }, 500);
    };
    const doCopy = async () => {
      if (pid) {
        let index = window.location.href.lastIndexOf("/");
        let url = window.location.href.substring(0, index);
        url += "/index?pid=" + pid;
        if (articleId.value) {
          url = window.location.href;
        }
        try {
          await toClipboard(url);
          ElMessage.success("复制地址成功");
        } catch (e) {
          console.log(e);
          ElMessage.success("复制失败");
        }
      } else {
        ElMessage.error("请先获取pid");
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "",
        class: "position-fiexd",
        style: _normalizeStyle([{
          "left": "0",
          "top": "0",
          "right": "0",
          "z-index": "12"
        }, _unref(maxW) ? 'max-width:' + _unref(maxW) + 'px;' : ''])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("em", _hoisted_3, _toDisplayString(userInfo.value.id ? "ID:" + userInfo.value.id : ""), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(title.value), 1), _createElementVNode("em", _hoisted_5, _toDisplayString(userInfo.value.level ? "Level:" + userInfo.value.level : ""), 1)]), timer.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(timeFomat.value), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = $event => doCopy()),
        class: "",
        src: _imports_1,
        style: {
          "width": "25px",
          "height": "25px",
          "margin-top": "10px",
          "margin-right": "10px"
        }
      })])])], 4);
    };
  }
};